import useIsInExperiment from '~/hooks/common/experiments/useIsInExperiment';

export default function useIsInMiniHeroExperiment() {
  return useIsInExperiment('car-merch-ui-vdp-mini-hero', 'treatment');
}
